/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, total: NonNullable<unknown> }} Partner_Billing_Board_Meta_FilteredInputs */



/**
* | output |
* | --- |
* | "{matched} of {total} partners match" |
*
* @param {Partner_Billing_Board_Meta_FilteredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_filtered = /** @type {((inputs: Partner_Billing_Board_Meta_FilteredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_FilteredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.matched} von ${i?.total} Partnern entsprechen den Filtern`)
	return /** @type {LocalizedString} */ (`${i?.matched} of ${i?.total} partners match`)
});